import { connect } from 'react-redux';
import { Calendar } from './calendar-view';
import { getActiveJobs, createAppointment, selectAppointment } from '../../reducers/calendar';

const mapStateToProps = state => {
    return {
        activeJobs: state.calendar.activeJobs,
        loading: state.calendar.loading,
        templates: state.calendar.appointmentTypes,
        company: state.companies.company,
    };
};

const mapDispatchToProps = {
    dispatchGetActiveJobs: () => getActiveJobs(),
    dispatchSetAppointment: (appointment) => createAppointment(appointment),
    dispatchSelectAppointment: (appointment) => selectAppointment(appointment),
}

const calendar = connect(mapStateToProps, mapDispatchToProps)(Calendar);

export default calendar;
